export const environment = {
    production: false,
    env: 'normal',
    apiUrl: 'https://apie4g-ssp.asmadiya.net/siemens/api',
    fileUrl: '',
    ssphubUrl:'https://apisiemensenergy-uat.asmadiya.net',
    disableLogs: false
};

